import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5">
      <div className="max-w-md w-full text-center bg-[#111] border border-white/10 p-10">
        <XCircle className="h-14 w-14 mx-auto text-neutral-500" />
        <h1 className="mt-6 font-display text-2xl font-bold">Checkout cancelled</h1>
        <p className="mt-2 text-sm text-neutral-400">No charge was made. You can pick a plan whenever you're ready.</p>
        <div className="mt-7 flex gap-3">
          <Link to="/pricing" className="flex-1"><Button className="w-full rounded-none bg-[#D4AF37] text-black hover:bg-[#F0C84B] font-semibold" data-testid="cancel-pricing">View plans</Button></Link>
          <Link to="/dashboard" className="flex-1"><Button variant="outline" className="w-full rounded-none border-white/20 bg-transparent text-white hover:border-[#D4AF37] hover:text-[#D4AF37]">Dashboard</Button></Link>
        </div>
      </div>
    </div>
  );
}
